import { AxiosError } from "axios";
import axiosInstance from "services/axiosInstance";

interface ApiError {
  message: string;
  errors?: Record<string, string[]>;
}

export function apiUpdate<T>(url: string) {

  const handleSubmit = async (data: Record<string, any>) => {
    try {
      const response = await axiosInstance.put<T>(url, data);
      return response.status;
    } catch (err) {
      const axiosError = err as AxiosError<ApiError>;
      if (axiosError.response) {
        const statusCode = axiosError.response.status;
        const errorData = axiosError.response.data;

        if (statusCode === 422) {
          let errorMessages = "Por favor, corrija os seguintes erros:\n";

          if (errorData.errors) {
            for (const [field, messages] of Object.entries(errorData.errors)) {
              errorMessages += `${messages.join(", ")}\n`;
            }
          }
          alert(errorMessages);
        } else if (statusCode === 409) {
          const conflictMessage = "Já existe referência cadastrada.";
          alert(conflictMessage);
        } else {
          const genericMessage = `Erro com código de status: ${statusCode}`;
          alert(genericMessage);
        }
      } else {
        const unknownError = `Erro desconhecido: ${err}`;
        alert(unknownError);
      }
    }
  };

  return {
    handleSubmit,
  };
}
